import React, {useEffect, useState, useContext } from "react";
import { Modal } from "./Modal";
import { JustBooked } from "./JustBooked";
import { compose } from "recompose";
import withFosRouter from "../FosRouter/withFosRouting";
import withTranslator from "../Translator/withTranslation";
import LazyLoad from 'react-lazyload';
import styled from "@emotion/styled";
import { LoadingAnimation } from "./LoadingAnimation";
import TrustBox from "./Trustpilot.js";
import { TrustpilotLocaleMap } from "../Data/APIData";
import { MailchimpSignup } from "./MailchimpSignup";
import { RenderContext } from "../Context/Ssr";

const ContentContainer = styled.div`
    padding: 4em 1em;
    max-width:1600px;
    margin:auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    
    @media (max-width:767px){
        display:block;
        padding: 4em 0;
    }
`;

const getLloretBlogUrl = (locale) => {
    switch (locale) {
        case 'en':
            return 'https://www.clubvillamar.com/content/lloret-de-mar/';
        break;
        case 'fr':
            return 'https://www.clubvillamar.fr/content/lloret-de-mar/';
        break;
        case 'de':
            return 'https://www.clubvillamar.de/content/lloret-de-mar/';
        break;
        case 'nl':
            return 'https://www.clubvillamar.nl/content/lloret-de-mar/';
        break;
        case 'es':
            return 'https://www.clubvillamar.es/content/lloret-de-mar/';
        break;
        case 'it':
            return 'https://www.clubvillamar.it/content/lloret-de-mar/';
        break;
        case 'ru':
            return 'https://www.clubvillamar.ru/content/lloret-de-mar/';
        break;
        case 'ca_es':
            return 'https://www.clubvillamar.cat/content/lloret-de-mar/';
        break;
        case 'no':
        case 'da':
            return 'https://www.clubvillamar.com/content/lloret-de-mar/';
        break;
    }
}
const PaymentLogoImg = styled.img`
    max-height: 40px;
    max-width:40px;
    width:5%;
    @media (max-width:1024px){
        width:8%;
    }
    @media(max-width:499px) {
        width:10%;
    }
`;
const stripTags = (html) => {
    return html.replace(/(<([^>]+)>)/ig,"");
}
const ResponsiveFooter = (props) => {
    const [mobile, setMobile] = useState(props.mobile);
    const [modal, setModal] = useState(false);
    const { t , r, locale} = props;
    const render = useContext(RenderContext);

    const resizeHandler = (e) => {
        setMobile(e.detail.properties.mobile);
    }

    useEffect( () => {
            document.addEventListener("CheckWindowResize", resizeHandler);
            return () => {
                document.removeEventListener("CheckWindowResize", resizeHandler);
            };
        }, [mobile, setMobile]
    );
    const onClose = () => {
        setModal(false);
    }
    const onClick = (route) => {
        if(!route) return;

        setModal(<Modal key="modalLoading"  loading={true} onClose={onClose} />)
 
        fetch(route)
            .then(response => response.text())
            .then(data => setModal( <Modal 
                key="modalLoaded"
                content={data}
                setHTML={true}
                onClose={onClose}
                />
        ));
    }

    var FooterTopData = [
        {
            className: "col-xl-2 col-sm-6",
            image: "/assets/img/front/icons/satisfactionv3-reversed.svg",
            onClick: '/satisfaction',
            label: t('satisfaction'),
            width: mobile ? 42 : 51 
        },
        {
            className: "col-xl-2 col-sm-6",
            image: "/assets/img/front/icons/lowestpricev2-reversed.svg",
            onClick: '/lowestprice',
            label: t('lowerGuaranteed'),
            width: mobile ? 26 : 32
        },
        {
            className: "col-xl-2 col-sm-6",
            image: "/assets/img/front/icons/trustpilot-reversed.svg",
            label: t('great_rating')+ " Trustpilot",
            width: mobile ? 53 : 63
        },
        {
            className: "col-xl-2 col-sm-6",
            image: "/assets/img/front/icons/professional-cleaning-reversed.svg",
            label: t('usp_professionalcleaning'),
            width: mobile ? 60 : 60
        },
        {
            className: "col-xl-2 col-sm-6",
            image: "/assets/img/front/icons/mastercard-visa-reversed.svg",
            label: t('safe_payment'),
            width: mobile ? 160 : 160
        }
    ];
    var FooterBottomSecondColumn = [
        {
            url: r('content_contact'),
            label: t('contact',{}, 'messages')
        }
    ];
    var FooterBottomData = [
        {
            className: "col-xl-3 col-sm-4",
            items: [
                {
                    url: r('show_region', {'country': t('spain').toLowerCase(), 'region': 'costa-brava'}),
                    label: t('villas_footer') + " " + t('costabrava')
                },
                {
                    url: r('show_region', {'country':t('spain').toLowerCase(), 'region': 'costa-blanca'}),
                    label: t('villas_footer') + " " + t('costablanca')
                },
                {
                    url: r('show_city', {'country': t('spain').toLowerCase(), 'region': 'costa-brava', 'city': 'lloret-de-mar'}),
                    label: t('villas_footer') + " " + t('lloretdemar')
                },
                {
                    url: r('show_city', {'country': t('spain').toLowerCase(), 'region': 'costa-brava', 'city': 'tossa-de-mar'}),
                    label: t('villas_footer') + " " + t('tossademar')
                },
                {
                    url: r('show_city', {'country': t('spain').toLowerCase(), 'region': 'costa-brava', 'city': 'blanes'}),
                    label: t('villas_footer') + " " + t('blanes')
                },
                {
                    url: getLloretBlogUrl(locale),
                    label: t('lloretdemar')
                }
            ]
        },
        {
            className: "col-xl-3 col-sm-4",
            items: FooterBottomSecondColumn
        },
        {
            className: "col-xl-3 col-sm-4",
            items: [
                {
                    url: r('homeowner_welcome'),
                    label: t('homeownerModule')
                },
                {
                    url: r('content_partners'),
                    skip: locale === 'nl' ? true : false,
                    label: t('partners')
                },
                {
                    url: "https://realestate.clubvillamar.com",
                    label: "Real Estate by Club Villamar"
                }
            ]
        }
    ];

    switch(locale){ //showLastMinutes
        case 'de': case 'ru': case 'es': case 'da': case 'no':               
            break;
        default:
            FooterBottomSecondColumn.push({
                url: r('content_lastminutes'),
                label: t('last_minute') 
            });
            break;
    }
    switch(locale){ //showSurroundings
        case 'no': case 'da': case 'it': case 'ca_es':
        break;
        case 'nl':
            FooterBottomSecondColumn.push({
                url: r('landing', {'uri': 'spanje/' } ),
                label: t('surroundings_menu')
            });
            break;
        case 'es':
            FooterBottomSecondColumn.push({
                url: r('landing', {'uri': 'espana/' } ),
                label: t('surroundings_menu')
            });
            break;
        case 'fr':
            FooterBottomSecondColumn.push({
                url: r('landing', {'uri': 'espagne/' } ),
                label: t('surroundings_menu')
            });
            break;
        case 'de':
            FooterBottomSecondColumn.push({
                url: r('landing', {'uri': 'spanien/' } ),
                label: t('surroundings_menu')
            });
            break;
        default: 
            FooterBottomSecondColumn.push({
                url: r('landing', {'uri': 'spain/' } ),
                label: t('surroundings_menu')
            });
            break;
    }
    FooterBottomSecondColumn.push({
        url: r('content_aboutus'),
        label: t('about_us') 
    });
    
    FooterBottomSecondColumn.push({
        url: r('content_faq'),
        label: t('faq_short') 
    });
    
    switch(locale){ //showWhatOurGuestsSay
        case 'fr':
            FooterBottomSecondColumn.push({
                url: r('landing', {'uri' : 'avis-client/' }),
                label: t('whatourguestssay') 
            });
            break;
        case 'en': case 'nl': case 'ru':
            FooterBottomSecondColumn.push({
                url: r('landing', {'uri' : 'reviews/' }),
                label: t('whatourguestssay') 
            });
            break;
        case 'de':
            FooterBottomSecondColumn.push({
                url: r('landing', {'uri' : 'bewertungen/' }),
                label: t('whatourguestssay') 
            });
            break;
        default:
            break;
    }

    FooterBottomSecondColumn.push({
        url: r('privacy'),
        label: t('privacy_policy') 
    });

    const footerTopData = () => {
        return FooterTopData.map((item, index) => {
            return <div key={index} className={(item.className ? item.className : '')}>
            <div className={(!mobile ? "inline-block " : "flex items-center justify-saround " ) + "py-sm-6 pt-4 opacity-80 " + (item.onClick ? 'opacity-100-hover pointer ' : '')} onClick={() => onClick(item.onClick)}>
                <div style={mobile ? {width:'50px'} : {}} className={!mobile ? "" : "ml-3 "}>
                    <img className="valign-middle" src={(props.searchURLBase ? props.searchURLBase : '') + item.image} alt={item.label} width={item.width} />
                </div>
                <div className={(!mobile ? "mt-4 " : "width-100 ")}><strong>{item.label}</strong></div>
            </div>
        </div> 
        })
    }
    const footerBottomData = () => {
        return FooterBottomData.map((item, index) => {
            return (
            <div key={index} className={(item.className ? item.className : '')}>
                <div className={"text-left px-3 px-sm-0 py-xl-6 py-sm-4 py-4 bor-solid-xs bor-blue3 bor-thin bor-t-no bor-r-no bor-l-no " + (!mobile ? 'inline-block ' : '')}>
                     <ul>
                        { item.items.filter(function(subitem) {
                            return !subitem.skip;
                            }).map(function(subitem, index){
                                    return (
                                    <li key={index} className="mb-2">
                                        <a href={subitem.url}>{subitem.label}</a>
                                    </li>
                                    )
                                })
                        }
                        { (index === (FooterBottomData.length - 1) ) && (
                                <li>{render.serverSide && <div className="lazyload-placeholder"></div>}{!render.serverSide && <LazyLoad once> <MailchimpSignup locale={locale} /></LazyLoad>}</li>
                            )
                        }
                    </ul>
                </div> 
            </div> )
        });
    }
    const pagesTrustBoxAboveFooter = ['homepage', 'search', 'show_country', 'show_region', 'show_city', 'show_accommodation', 'show_accommodation_with_dates'];
    return (
            <div className="bg-blue2 children-white text-center"  >
                {modal ? modal : ''}
                <JustBooked mobile={mobile}/>
                { pagesTrustBoxAboveFooter.includes(props.route.route) && (
                    <LazyLoad once placeholder={<LoadingAnimation className="width-100"/>}>
                        <div className="bg-grey3">
                            <ContentContainer>
                                <h2 className="px-3 width-100 text-center font-w600 no-inherit-color blue1">{stripTags(t('what_our_guest_say_trustpilot'))}</h2>
                                <TrustBox
                                    locale={TrustpilotLocaleMap[props.locale].locale}
                                    template={TrustpilotLocaleMap[props.locale].template}
                                    businessunit={TrustpilotLocaleMap[props.locale].businessunit}
                                    tpurl={TrustpilotLocaleMap[props.locale].tpurl}
                                    stars="4,5"
                                />
                            </ContentContainer>
                        </div>
                    </LazyLoad>
                    )
                }
                <div className={(props.className ? props.className : '')}>
                    {!props.hideTop ?
                    <div className={"container-fluid "+ (props.topClass ?props.topClass : '')}>
                        <div className="row justify-saround">
                        {footerTopData()}
                        </div>
                        <div className="flex pt-3 pt-md-0 pt-lg-3 pb-lg-0 pb-3 px-3 justify-center">
                            <PaymentLogoImg src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/ideal.svg"} height="40" width="92" className="bg-white p-1 "  />
                            <PaymentLogoImg src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/method-mastercard.svg"} height="40" width="92" className="bg-white p-1" />
                            <PaymentLogoImg src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/method-visa.svg"} height="40" width="92" className="bg-white p-1" />
                            <PaymentLogoImg src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/sofort-de.svg"} height="40" width="92" className="bg-white p-1 py-2" />
                            <PaymentLogoImg src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/sofort.svg"} height="40" width="92" className="bg-white p-1 " />
                            <PaymentLogoImg src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/cbc-be.svg"} height="40" width="92" className="bg-white p-1 " />
                            <PaymentLogoImg src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/kbc-be.svg"} height="40" width="92" className="bg-white p-1 " />
                            <PaymentLogoImg src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/giropay.svg"} height="40" width="92" className="bg-white p-1 py-2" />
                            <PaymentLogoImg src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/belfius.svg"} height="40" width="92" className="bg-white p-1  py-2 " />
                            <PaymentLogoImg src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/bancontact-mister-cash.svg"} height="40" width="92" className="bg-white p-1 px-2" />
                        </div>
                    </div>
                    :''}
                    {!props.hideBottom ?
                    <div className={"container-fluid pb-6 " + (props.topClass ?props.topClass : '')}>
                        {mobile ? 
                        <hr className="bor-blue3 mt-5"/>
                        :''}
                        <div className="row justify-saround">
                            {footerBottomData()}
                            <div className="col-xl-3 col-sm-12 bor-solid-xs">
                                <div className={"text-left px-3 px-sm-0 py-xl-6 py-sm-4 py-4 " + (!mobile ? 'inline-block' : '')}>
                                    <div className="white font-120"><strong>{t('rentyourvilla.badge.header')}</strong></div>
                                    <p className="white my-3">{t('rentyourvilla.badge.question')}</p>
                                    <div className="mt-5">
                                        <a  className="btn btn-primary white btn-block bor-white bor-white-hover" href={r('accommodation_acquisition')}>{t('readmore')}</a>
                                    </div>
                                </div>
                            </div>
                            <div className="my-3 col-sm-12">
                                <div className="flex justify-center">
                                    <a href="https://www.instagram.com/clubvillamar/" className="inline-block mx-3" target="_blank">
                                        <img src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/instagram-reversed.svg"} height="30" width="30" alt="Instagram" title="Instagram"/>
                                    </a>
                                    <a href="https://www.facebook.com/ClubVillamar" className="inline-block mx-3" target="_blank">
                                        <img src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/facebook-reversed.svg"} height="30" width="16" alt="Facebook" title="Facebook"/>
                                    </a>
                                    <a href={"https://twitter.com/Clubvillamar" + (['en','fr','nl','de'].includes(props.locale) ? props.locale.toUpperCase() : 'EN')} className="inline-block mx-3"  target="_blank">
                                        <img src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/twitter-reversed.svg"} height="30" width="37" alt="Twitter" title="Twitter"/>
                                    </a>
                                    <a href="https://www.youtube.com/user/ClubVillamar?sub_confirmation=1" className="inline-block mx-3"  target="_blank">
                                        <img src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/youtube-reversed.svg"} height="30" width="25" alt="Youtube" title="Youtube"/>
                                    </a>
                                    <a href="https://www.tiktok.com/@clubvillamar" className="inline-block mx-3"  target="_blank">
                                        <img src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/tiktok-reversed.svg"} height="30" width="25" alt="TikTok" title="TikTok"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    :''}
                </div>
                { !pagesTrustBoxAboveFooter.includes(props.route.route)  && (
                    <LazyLoad once placeholder={<LoadingAnimation className="width-100"/>}>
                        <div className="bg-grey3">
                            <ContentContainer>
                                <h2 className="px-3 width-100 text-center font-w600 no-inherit-color blue1">{stripTags(t('what_our_guest_say_trustpilot'))}</h2>
                                <TrustBox
                                    locale={TrustpilotLocaleMap[props.locale].locale}
                                    template={TrustpilotLocaleMap[props.locale].template}
                                    businessunit={TrustpilotLocaleMap[props.locale].businessunit}
                                    tpurl={TrustpilotLocaleMap[props.locale].tpurl}
                                    stars="4,5"
                                />
                            </ContentContainer>
                        </div>
                    </LazyLoad>
                    )
                }
            </div>
        );
}

export const ResponsiveFooterInner = compose(
    withFosRouter,
    withTranslator
)(ResponsiveFooter);